import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ProjectCard from '../components/Projects/ProjectCard';
import Particle from '../components/Particle';
import projectInfo from './projectsInfo';

const Projects = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent Top <strong className="yellow">Works </strong>
        </h1>
        <p style={{ color: 'white' }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
          {projectInfo.map((project) => (
            <Col key={project.id} md={4} className="project-card">
              <ProjectCard
                imgPath={project.imgPath}
                title={project.title}
                description={project.description}
                ghLink={project?.ghLink}
                demoLink={project?.demoLink}
                isBlog={project.isBlog}
              />
            </Col>
          ))}
        </Row>
        <p style={{ color: 'white' }}>For more projects visit GitHub!</p>
      </Container>
    </Container>
  );
};

export default Projects;
